<script lang="ts">
  import { createEventDispatcher, onMount } from 'svelte';

  import type { AnimationItem, LottiePlayer } from 'lottie-web';

  import animationData from '../data/DO-text-lottie.json';
  import { initLottieLifecycle } from '../libs';
  import { textDOTriggers } from '../models';
  import { triggeredUIDs } from '../models/triggered-UIDs';
  import type { LottieUID } from '../types';

  const dispatch = createEventDispatcher<{ 'lottie-loaded': void }>();

  export let uid: LottieUID;
  initLottieLifecycle(uid);

  export let width: number;

  $: ({ appear } = $textDOTriggers); // <- Triggers

  $: appear && lot && triggeredUIDs.exist(uid, 'appear') && appearAnimation();

  let lot: AnimationItem;
  function appearAnimation() {
    lot.setLoop(false);
    lot.play();
  }

  let container: HTMLDivElement;
  onMount(async () => {
    const lottie = (await import('lottie-web')) as unknown as LottiePlayer;
    lot = lottie.loadAnimation({
      container,
      animationData,
      loop: true,
      autoplay: false,
    });
    dispatch('lottie-loaded');
  });
</script>

<div bind:this="{container}" style="width: {width}px;"></div>
